import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';

interface Props extends RouteProps {
	component: Exclude<RouteProps['component'], undefined>;
}

const UnauthorizedRoute: React.FC<Props> = ({ component, ...rest }) => {
	const { keycloak } = useKeycloak();
	const render = (props: RouteComponentProps) => {
		const Component = component;
		if (!keycloak.authenticated) return <Component {...props} />;
		const from = Reflect.get(props.location?.state || {}, 'from');
		return from ? <Redirect to={{ ...from }} /> : <Redirect to="/" />;
	};
	return <Route {...rest} render={render}></Route>;
};

export default UnauthorizedRoute;
